/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgDownloadList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <rect width={23} height={23} x={0.5} y={0.5} stroke="currentColor" rx={1.5} />
    <rect width={11.333} height={1.333} x={6.667} y={7.475} fill="currentColor" rx={0.667} />
    <path
      fill="currentColor"
      d="M6.667 12.143c0-.368.298-.666.667-.666h10a.667.667 0 0 1 0 1.333h-10a.667.667 0 0 1-.667-.667Z"
    />
    <rect width={11.333} height={1.333} x={6.667} y={15.475} fill="currentColor" rx={0.667} />
  </svg>
)
const Memo = memo(SvgDownloadList)
export default Memo
